import {
	usageMap,
	goalMap,
	featureMap,
} from '../data'

export default {
	getUsage : (state, getters) => (slug) => {
		return usageMap.find(f => slug === f.slug)
	},
	getGoal : (state, getters) => (slug) => {
		return goalMap.find(f => slug === f.slug)
	},
	goalDescription : (state, getters, rootState, rootGetters) => {
		const goal = getters.getGoal(rootGetters.onboardingGoal)
		return goal && goal.title ? goal.title : ''
	},
	featureMap : () => featureMap,
	getFeature : (state, getters) => (slug) => {
		return featureMap.find(f => slug === f.slug)
	},
	features : (state, getters) => {
		return state.extraFeatures
			.map(f => getters.getFeature(f))
	},
	proFeatures (state, getters) {
		return getters.features
			.filter(f => !f.plugin)
	},
	getFeatureProp : (state, getters) => (slug, property) => {
		const feature = getters.getFeature(slug)
		return feature ? feature[property] : false
	},
	inExtraFeatures : (state, getters) => (value) => {
		return state.extraFeatures && -1 !== state.extraFeatures.indexOf(value)
	},
}
